







import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import PageLeftHook from '@/components/mixins/PageLeftHook.vue';
import PageFetchHook from '@/components/mixins/PageFetchHook';
import store from '@/store';
import * as CvSectionGalleryItemStoreEdit from '@/store/modules/cvSectionGalleryItemEdit';
import EditContainer from '@/containers/cv-section-gallery-item/edit.vue';

const { mapGetters } = createNamespacedHelpers(
  CvSectionGalleryItemStoreEdit.namespace
);

const fetch = async function(params) {
  const { cv_id, cv_section_gallery_id, id } = params;
  await store.dispatch(
    CvSectionGalleryItemStoreEdit.GetCvSectionGalleryItem.namespaced({
      params: { cv_id, cv_section_gallery_id, id },
    })
  );
};

export default Vue.extend({
  components: {
    EditContainer,
  },
  mixins: [PageLeftHook, PageFetchHook(fetch)],
  data() {
    return {
      storeList: [CvSectionGalleryItemStoreEdit],
    };
  },
  computed: {
    ...mapGetters(['cvSectionGalleryItem']),
  },
});
